import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RegulatoryReportType } from 'src/app/core/models/reports';
import { differenceInCalendarDays } from 'src/app/utils/date.utils';

@Component({
  selector: 'app-deadline-countdown',
  templateUrl: './deadline-countdown.component.html',
  styleUrls: ['./deadline-countdown.component.scss'],
})
export class DeadlineCountdownComponent implements OnInit, OnChanges {
  @Input() deadline!: Date;
  @Input() variant: RegulatoryReportType = 'z4';

  timeRemaining = '';
  isUrgent = false;
  isCritical = false;

  get variantClass(): string {
    return `countdown-${this.variant ?? 'z4'}`;
  }

  constructor(private readonly translate: TranslateService) {}

  ngOnInit(): void {
    this.updateCountdown();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['deadline'] || changes['variant']) {
      this.updateCountdown();
    }
  }

  private updateCountdown(): void {
    const days = differenceInCalendarDays(this.deadline, new Date());

    this.isUrgent = false;
    this.isCritical = false;
    this.timeRemaining = '';

    if (days < 0) {
      this.timeRemaining = this.translate.instant(
        'translations.newReports.deadlineCountdown.overdue'
      );
      this.isCritical = true;
      return;
    }

    if (days === 0) {
      this.timeRemaining = this.translate.instant(
        'translations.newReports.deadlineCountdown.dueToday'
      );
      this.isCritical = true;
    } else if (days === 1) {
      this.timeRemaining = this.translate.instant(
        'translations.newReports.deadlineCountdown.oneDayLeft'
      );
      this.isCritical = true;
    } else if (days <= 7) {
      this.timeRemaining = this.translate.instant(
        'translations.newReports.deadlineCountdown.daysLeft',
        { days }
      );
      this.isUrgent = true;
    } else {
      this.timeRemaining = this.translate.instant(
        'translations.newReports.deadlineCountdown.daysLeft',
        { days }
      );
    }
  }
}
